export default __webpack_public_path__ + "static/media/lis.24970361.png";